export async function nameGeneratorAPI(name_type, desc, num, lang) {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")

    const raw = JSON.stringify({
        "name_type": name_type,
        "desc": desc,
        "num": num,
        "lang": lang
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
    };

    const res = await fetch("https://easycomment.ai/api/web/v1/name-generate", requestOptions)

    if (!res) return false

    return await res.json()
}
